import React, { useEffect } from 'react';
import NProgress from 'nprogress';
import {
  Box,
  CircularProgress,
  makeStyles,
  Typography
} from '@material-ui/core';
import { Alert } from '@material-ui/lab';
import getProductType from './ProductType';

const useStyles = makeStyles(theme => ({
  root: {
    alignItems: 'center',
    backgroundColor: theme.palette.background.default,
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    justifyContent: 'center',
    minHeight: '100%',
    padding: theme.spacing(3)
  }
}));

function LoadingScreen({ extra, text, ...rest }) {
  const classes = useStyles();

  const productType = getProductType();

  useEffect(() => {
    NProgress.start();

    return () => {
      NProgress.done();
    };
  }, []);

  return (
    <div className={classes.root}>
      <Box position="relative" display="inline-flex">
        <CircularProgress size={100} thickness={1.5} color="primary" />
        <Box
          top={0}
          left={0}
          bottom={0}
          right={0}
          position="absolute"
          display="flex"
          alignItems="center"
          justifyContent="center"
        >
          <Typography variant="caption" component="div" color="textSecondary">
            <img
              alt="Logo"
              src={
                productType === 'Signzy'
                  ? '/static/signzy.png'
                  : '/static/logoForLoading.png'
              }
              style={{ height: 70 }}
            />
          </Typography>
        </Box>
      </Box>
      {text && (
        <Box pt={2} display="flex" alignItems="center" justifyContent="center">
          <Alert
            icon={false}
            severity="info"
            style={{ padding: '0 10px 0 10px' }}
          >
            <Typography variant="h6">{text}</Typography>
          </Alert>
        </Box>
      )}
      {extra && (
        <>
          <Box
            pt={2}
            display="flex"
            alignItems="center"
            justifyContent="center"
          >
            <Typography variant="h4" color="textPrimary">
              Processing order
            </Typography>
          </Box>
          <Box
            pt={2}
            display="flex"
            alignItems="center"
            justifyContent="center"
          >
            <Typography color="textSecondary" variant="body1">
              Thank you for your order. Please wait while we process your
              payment.
            </Typography>
          </Box>
        </>
      )}
    </div>
  );
}

export default LoadingScreen;
